import { teddyPhotoPath, type TeddyKey } from '@hazel/shared'

/**
 * The pictures the races are run with.
 *
 * All finished artwork now. The paths live here rather than at five call sites
 * so that swapping one is a one-line change — which is how the placeholders
 * these replaced came out.
 */
export const RACE_ART = {
  carrot: '/race/carrot.webp',
  banana: '/race/banana.webp',
  pearl: '/race/pearl.webp',
  burrow: '/race/burrow.webp',
  trolley: '/race/trolley.webp',
  apple: '/race/apple.webp',
  /*
   * Drawn, not photographed — the one goal that is still a stand-in.
   *
   * Kept as an `.svg` rather than named `.webp` so that nothing pretends this
   * is finished artwork: the day a bone.png arrives it is converted and this
   * line changes, which is exactly how the other five went.
   */
  bone: '/race/bone.svg',
  /** No teddy exists for Daddy, so he has a picture of his own. */
  daddy: '/race/daddy.webp',
} as const

/** A teddy's own picture, for the ones who race as themselves. */
export function racerPicture(teddy: TeddyKey): string {
  return teddyPhotoPath(teddy)
}

/** Lane colours, kept apart so two racers never share a rail colour. */
export const LANE = {
  hoppity: 'bg-teal/30',
  daddy: 'bg-coral/30',
  monkey: 'bg-amber/40',
  sky: 'bg-primary/30',
  rabbit: 'bg-lime/40',
  turtley: 'bg-teal/40',
  rocky: 'bg-lime/30',
  // The pink in the palette, for a pink squishmallow. Daddy has coral at a
  // lighter weight and they never share a track — Stripey's is a solo lane.
  stripey: 'bg-coral/40',
} as const
